<template>
  <div class="existing-project-shell">
    <div ref="host" class="product-scene-host" dir="ltr"></div>
    <Teleport v-if="target" :to="target"><slot /></Teleport>
  </div>
</template>
<script setup>
// Reuse the SAME shell renderer/styles as the site's existing ProductScene.
// Only its Projects content slot is replaced. No new scaffold or navigation.
const host=ref(null),target=shallowRef(null);
const {injectCss}=useProductLab();
let api,observer,visibility;
let destroyed=false;
const syncTheme=()=>host.value?.querySelector('.faithful')?.classList.toggle('is-dark',document.documentElement.classList.contains('dark'));
const mount=async()=>{
 injectCss();
 const url='/product-lab/replicas.js?v=motion-11';
 const mod=await import(/* @vite-ignore */ url);
 if(destroyed||!host.value)return;
 api=mod.mountReplica(host.value,{scene:'projects',compact:false,onNotify:()=>{}});
 const body=host.value.querySelector('.app-body');
 body.replaceChildren();
 // Existing outer chrome is context for this focused Projects study.
 host.value.querySelectorAll('.app-sidebar,.app-header').forEach(el=>el.inert=true);
 target.value=body;
 syncTheme();observer=new MutationObserver(syncTheme);
 observer.observe(document.documentElement,{attributes:true,attributeFilter:['class']});
};
onMounted(()=>{
 visibility=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){visibility.disconnect();mount().catch(()=>{if(host.value)host.value.textContent='Projects preview unavailable. Explore the project features below.';});}},{rootMargin:'160px'});
 visibility.observe(host.value);
});
onBeforeUnmount(()=>{destroyed=true;visibility?.disconnect();observer?.disconnect();api?.destroy();});
</script>
<style scoped>
.existing-project-shell{border:1px solid #dbe1e7;border-radius:12px;overflow:hidden;box-shadow:0 28px 60px -35px #1b405930}.dark .existing-project-shell{border-color:#344253}.product-scene-host{height:auto;min-height:480px}.existing-project-shell :deep(.replica){height:auto;min-height:480px}
</style>
